export const batch = {
  logEvent: 'events/create-event',
};
